import React, { useEffect, useState } from "react";
import CardComponent from "../cardComponents/CardComponent";
import AccordionComponent from "../accordion/AccordionComponent";
// import { CreditCardData } from './CardData'
import Http from "../../Http";
import { CARD_API } from "../../Helper";
import { MdOutlineAirplanemodeActive } from "react-icons/md";
import { BsCashCoin } from "react-icons/bs";
import { MdStars } from "react-icons/md";
import { BsFillFuelPumpFill } from "react-icons/bs";
import { FaInfinity } from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import FAQSchema from "../../FAQSchema";
import { motion } from "framer-motion";
import {
  FaMedal,
  FaRegHandshake,
  FaHotel,
  FaReceipt,
  FaLayerGroup,
  FaGlobeAmericas,
  FaPhoneAlt,
} from "react-icons/fa";
import { FaGift, FaBriefcase, FaRegSmileBeam } from "react-icons/fa";
import { MdCardMembership } from "react-icons/md"; // Optional for lifestyle
import {
  FaFileAlt,
  FaWpforms,
  FaListAlt,
  FaRegCreditCard,
  FaRegCheckCircle,
} from "react-icons/fa";
import { BadgeCheck, FileText } from "lucide-react";
import {
  FaMoneyCheckAlt,
  FaClipboardCheck,
  FaBalanceScale,
  FaWallet,
  FaStar,
  FaHeadset,
} from "react-icons/fa";
function Icon({ id, open }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={2}
      stroke="currentColor"
      className={`${
        id === open ? "rotate-180" : ""
      } h-5 w-5 transition-transform`}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19.5 8.25l-7.5 7.5-7.5-7.5"
      />
    </svg>
  );
}
const LifeTimeFee = () => {
  const [CreditCardData, setCreditCardData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [cardsPerPage] = useState(10);
  // const location = useLocation()
  // console.log(location.state)
  useEffect(() => {
    Http.post(CARD_API)
      .then((res) => {
        setCreditCardData(res);
        // console.log("Card API Response:", res);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const indexOfLastCard = currentPage * cardsPerPage;
  const indexOfFirstCard = indexOfLastCard - cardsPerPage;
  console.log({ indexOfLastCard, indexOfFirstCard });
  const currentCards = CreditCardData.cards
    ?.filter((cards) => cards.category_name === "Lifetime Free")
    .slice(indexOfFirstCard, indexOfLastCard);
  console.log({ currentCards });

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const [activeIndex, setActiveIndex] = useState(0);

  const faqs = [
    {
      question: "Can a lifetime free credit card offer rewards?",
      answer:
        "Yes, many offer basic rewards or cashback on essential spends like groceries, utilities, and fuel, even without annual fees.",
    },
    {
      question: "Are there hidden charges in lifetime free cards?",
      answer:
        "While there is no annual fee, charges like interest on late payments, cash advance fees, or over-limit penalties may apply.",
    },
    {
      question: " Do lifetime free cards support contactless payments?",
      answer:
        "Yes, most modern cards are NFC-enabled for quick tap-and-pay functionality.",
    },
    {
      question: "Can I upgrade to a better card later?",
      answer:
        "Absolutely. Based on your usage and credit history, banks may offer you an upgrade to a card with more benefits.",
    },
    {
      question: "Will this help improve my credit score?",
      answer:
        "Yes, if you maintain low utilization and pay on time, lifetime free cards can significantly boost your credit score.",
    },
    {
      question: "Does TheFinMaster issue cards directly?",
      answer:
        "No. TheFinMaster is a fintech aggregator. We help users compare and evaluate cards, but redirection to the banks application page is required to complete the process.",
    },

    {
      question:
        "What is the difference between a lifetime free card and a zero annual fee card?",
      answer:
        "A lifetime free card has no joining or annual fees for the entire duration, while a zero annual fee card may waive fees only for the first year or under specific spending conditions.",
    },
    {
      question: "Are lifetime free credit cards suitable for beginners?",
      answer:
        "Yes, they are ideal for first-time users. They offer basic features, no annual cost, and help build a healthy credit history without financial pressure.",
    },
    {
      question: "Can I own multiple lifetime free credit cards?",
      answer:
        "Yes, you can hold more than one lifetime free credit card if you meet the issuer’s eligibility criteria. However, managing multiple cards responsibly is important.",
    },
    {
      question: "Do lifetime free cards come with cashback or discounts?",
      answer:
        "Many lifetime free credit cards do offer cashback, fuel surcharge waivers, and discounts on dining or shopping. The benefits may be modest compared to premium cards but still valuable.",
    },
    {
      question: "What is the minimum income required for a lifetime free card?",
      answer:
        "The income requirement varies by issuer, but many lifetime free cards are available to individuals earning as low as ₹15,000–₹25,000 per month.",
    },
    {
      question: "Are these cards accepted internationally?",
      answer:
        "Some lifetime free credit cards support international usage, though foreign transaction charges may apply. Check with the issuer for global acceptance details.",
    },
    {
      question: "Do lifetime free credit cards have credit limits?",
      answer:
        "Yes, like all credit cards, these come with assigned credit limits based on your income, credit score, and financial history, which may increase over time.",
    },
    {
      question: "Can I get instant approval for a lifetime free card?",
      answer:
        "Some banks offer instant digital approval based on eligibility, especially for pre-approved users or those with existing banking relationships.",
    },
    {
      question: "Will missing a payment on this card incur penalties?",
      answer:
        "Yes, even though the card is lifetime free, late payment fees, interest charges, and penalties still apply if you miss the due date.",
    },
    {
      question: "Can I close a lifetime free card anytime without charges?",
      answer:
        "Yes, you can cancel it at your convenience without paying any closure fee. Just ensure all dues are cleared and rewards are redeemed before closing.",
    },
  ];
  const steps = [
    {
      icon: <FaRegCheckCircle className="h-6 w-6 text-pink-500" />,
      title: "Submit Documents",
      description:
        "Upload documents such as PAN, Aadhaar, and income proof for verification. Banks use these to assess your creditworthiness.",
    },
    {
      icon: <FaRegCreditCard className="h-6 w-6 text-teal-500" />,
      title: "Fill Out the Application ",
      description:
        "  Click on the chosen card, and you’ll be redirected to the official bank page. Fill in your details such as name, income, contact info, and KYC documentation.",
    },
    {
      icon: <FaWpforms className="h-6 w-6 text-amber-500" />,
      title: "Choose the Right Card",
      description:
        "  Once you’ve reviewed your options, select the card that aligns best with your financial needs, spending patterns, and long-term goals. Whether it’s rewards, cashback, or ease of use—prioritize what matters most.",
    },
    {
      icon: <FaListAlt className="h-6 w-6 text-purple-600" />,
      title: "Check Eligibility",
      description:
        "Go through the eligibility conditions set by the issuing bank, such as income bracket, employment status, and credit score requirements. This step is crucial to avoid rejections.",
    },

    {
      icon: <FaFileAlt className="h-6 w-6 text-green-500" />,
      title: "Verification & Approval",
      description:
        " The bank verifies your submitted information and processes the application. If everything is in order, you’ll receive approval and the card will be dispatched within 7–10 business days.",
    },

    {
      icon: <FaFileAlt className="h-6 w-6 text-blue-600" />,
      title: " Compare Cards",
      description:
        " Begin by browsing and comparing various lifetime free cards on TheFinMaster.com based on features, benefits, eligibility criteria, and bank partnerships. Our curated comparison tools help you identify which card suits your lifestyle and spending behavior.",
    },
  ];
  const benefits = [
    {
      icon: <FaMedal className="text-3xl text-amber-600" />,
      title: "  Zero Annual and Joining Fees",
      description:
        " Enjoy full access to credit facilities without worrying about yearly maintenance costs, making it ideal for long-term usage and entry-level users.",
    },

    {
      icon: <FaRegHandshake className="text-3xl text-purple-600" />,
      title: "Concierge Services",
      description:
        " Get 24/7 access to concierge services for travel bookings, event reservations, dining, and emergencies. It’s like having a personal assistant on call for your lifestyle needs.",
    },
    {
      icon: <FaHotel className="text-3xl text-yellow-500" />,
      title: " Reward Points and Cashback",
      description:
        " Despite no fees, these cards often provide basic reward programs or cashback benefits on daily purchases like groceries, fuel, or bill payments.",
    },
    {
      icon: <FaReceipt className="text-3xl text-pink-500" />,
      title: "Fuel Surcharge Waiver",
      description:
        " Save on refueling by availing of a 1% fuel surcharge waiver at partnered petrol pumps, typically applicable to transactions within a defined range.",
    },

    {
      icon: <FaLayerGroup className="text-3xl text-green-600" />,
      title: "Interest-Free Period",
      description:
        "Most cards offer an interest-free credit window of up to 45–50 days if you pay your balance in full, helping manage short-term cash needs without incurring charges.",
    },

    {
      icon: <FaGlobeAmericas className="text-3xl text-red-500" />,
      title: "  Secure Online Payments",
      description:
        " Lifetime free cards come equipped with security features like OTP authentication, EMV chips, and fraud protection, ensuring safe digital transactions.",
    },
    {
      icon: <FaPhoneAlt className="text-3xl text-blue-500" />,
      title: " Global Acceptance",
      description:
        " These cards are generally accepted at both domestic and international merchants, both offline and online, giving you flexibility wherever you go.",
    },
  ];

  const factors = [
    {
      icon: FaMoneyCheckAlt,
      title: "Hidden Charges and Terms",
      desc: "   Even if a card is marketed as “lifetime free,” it’s important to read the fine print. Some banks may waive the annual fee but still impose charges on certain transactions such as cash withdrawals, late payments, or over-limit spends. Always check for any hidden terms, like compulsory spending milestones or inactivity penalties.",
    },
    {
      icon: FaLayerGroup,
      title: " Reward Structure and Redemption Flexibility",
      desc: " Look for cards that offer decent rewards or cashback on your routine expenses like groceries, fuel, and online shopping—even without an annual fee. Also, assess how flexible the redemption process is. Can you convert your points to cashback, vouchers, or air miles easily? A good reward ecosystem adds long-term value even without the upfront fee.",
    },

    {
      icon: FaClipboardCheck,
      title: "Welcome Offers and Ongoing Deals",
      desc: " Lifetime free credit cards often come with enticing welcome bonuses like free movie tickets, gift vouchers, or instant cashback. Beyond the welcome period, check if the card continues to provide value through ongoing offers—especially on platforms like Amazon, Flipkart, Zomato, or Swiggy.",
    },
    {
      icon: FaBalanceScale,
      title: " Interest Rates and Credit Limits",
      desc: "  Ensure that the card offers a competitive interest rate if you ever plan to carry a balance. Additionally, evaluate whether the credit limit provided is sufficient for your monthly needs. Some lifetime free cards may offer limited credit access compared to premium counterparts, which can impact your spending and credit utilization ratio.",
    },
    {
      icon: FaWallet,
      title: "Usage Categories and Fit for Lifestyle",
      desc: "   Select a card that aligns with your most frequent expenses. For example, if you spend mostly on groceries, fuel, or travel, look for cards that offer elevated benefits in those categories. The best card should complement your lifestyle, even without charging you yearly fees.",
    },
    {
      icon: FaGlobeAmericas,
      title: " International Usage and Forex Markup",
      desc: "  If you occasionally travel abroad or shop on international websites, check whether the card allows overseas transactions and what foreign exchange markup it charges. Many no-fee cards come with higher forex rates, so consider this factor if global usage is on your radar.",
    },
    {
      icon: FaStar,
      title: " Credit Score Impact and Build Potential",
      desc: "   Lifetime free credit cards are ideal for first-time users or those looking to build credit history. Choose a card from a reputed issuer that reports timely repayment behavior to credit bureaus. A card with consistent use and low-to-moderate utilization can help improve your credit score over time.",
    },
    {
      icon: FaHeadset,
      title: " Add-On Benefits and Customer Support",
      desc: "   Lastly, assess the added perks such as EMI conversion options, contactless payment, mobile wallet compatibility, and 24/7 customer support. While these may seem minor, they enhance your experience and provide convenience, especially in urgent or everyday situations.",
    },
  ];
  const toggleAccordion = (index) => {
    if (activeIndex === index) {
      // If the clicked question is already expanded, collapse it
      setActiveIndex(null);
    } else {
      // If the clicked question is not expanded, expand it
      setActiveIndex(index);
    }
  };
  return (
    <>
      <Helmet>
        <title>
          Lifetime Free credit cards come with nil annual and joining fees |
          Finmaster
        </title>
        <meta
          name="description"
          content="Lifetime Free credit cards come with nil joining and annual fees. Know about the top lifetime free credit cards 2024, rewards, cashback, discounts, and other benefits offered by them | Finmaster."
        />
        <meta
          name="keywords"
          content="sbi credit card life time free, hdfc credit card life time free, axis neo credit card review, icici bank lifetime free credit card, yes bank credit card lifetime free, au bank lit credit card, amazon pay icici bank credit card"
        />
        <link
          rel="canonical"
          href="https://thefinmaster.com/credit-card/best-lifetime-free-credit-cards"
        />
        <meta
          name="robots"
          content="max-snippet:-1, max-image-preview:standard"
        />
        <meta name="robots" content="max-video-preview:-1" />
      </Helmet>
      <FAQSchema faqs={faqs} />
      <div className="w-full flex flex-col items-center ">
        <div className=" mt-10 w-full flex flex-col items-center justify-center bg-black h-[200px] md:h-[300px] shadow-lg mb-5 border-b-8 border-blue-600">
          <h1 className="text-white text-4xl md:text-7xl text-center font-medium">
            LifeTime Free
          </h1>
          <p className="text-gray-200 text-lg md:text-2xl pt-2 px-4 text-center">
            Experience financial freedom and flexibility with our credit card
            options.
          </p>
        </div>
        <div className="flex flex-wrap   justify-center gap-4 lg:gap-6 mt-4">
          <Link
            to="/credit-card/best-cashback-credit-card"
            className="relative inline-flex items-center justify-start py-3 pl-4 pr-12 overflow-hidden font-semibold text-indigo-600 transition-all duration-150 ease-in-out rounded hover:pl-10 hover:pr-6 bg-gray-50 group"
          >
            <span class="absolute bottom-0 left-0 w-full h-1 transition-all duration-150 ease-in-out bg-indigo-600 group-hover:h-full"></span>
            <span class="absolute right-0 pr-4 duration-200 ease-out group-hover:translate-x-12">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span class="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-200">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span className="relative flex items-center">
              <BsCashCoin className="mr-2 text-black text-2xl" />{" "}
              <span className="text-black transition-colors duration-200 ease-in-out delay-100 group-hover:text-white">
                Cash Back
              </span>
            </span>
          </Link>

          <Link
            to="/credit-card/travel-credit-card"
            className="relative inline-flex items-center justify-start py-3 pl-4 pr-12 overflow-hidden font-semibold text-indigo-600 transition-all duration-150 ease-in-out rounded hover:pl-10 hover:pr-6 bg-gray-50 group"
          >
            <span class="absolute bottom-0 left-0 w-full h-1 transition-all duration-150 ease-in-out bg-indigo-600 group-hover:h-full"></span>
            <span class="absolute right-0 pr-4 duration-200 ease-out group-hover:translate-x-12">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span class="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-200">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span className="relative flex items-center">
              <MdOutlineAirplanemodeActive className="mr-4 text-black text-2xl" />{" "}
              <span className="text-black transition-colors duration-200 ease-in-out delay-100 group-hover:text-white">
                Travel
              </span>
            </span>
          </Link>
          <Link
            to="/credit-card/fuel-credit-card"
            className="relative inline-flex items-center justify-start py-3 pl-4 pr-12 overflow-hidden font-semibold text-indigo-600 transition-all duration-150 ease-in-out rounded hover:pl-10 hover:pr-6 bg-gray-50 group"
          >
            <span class="absolute bottom-0 left-0 w-full h-1 transition-all duration-150 ease-in-out bg-indigo-600 group-hover:h-full"></span>
            <span class="absolute right-0 pr-4 duration-200 ease-out group-hover:translate-x-12">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span class="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-200">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span className="relative flex items-center">
              <BsFillFuelPumpFill className="mr-4 text-black text-2xl" />{" "}
              <span className="text-black transition-colors duration-200 ease-in-out delay-100 group-hover:text-white">
                Fuel
              </span>
            </span>
          </Link>

          <Link
            to="/credit-card/best-premium-credit-card"
            className="relative inline-flex items-center justify-start py-3 pl-4 pr-12 overflow-hidden font-semibold text-indigo-600 transition-all duration-150 ease-in-out rounded hover:pl-10 hover:pr-6 bg-gray-50 group"
          >
            <span class="absolute bottom-0 left-0 w-full h-1 transition-all duration-150 ease-in-out bg-indigo-600 group-hover:h-full"></span>
            <span class="absolute right-0 pr-4 duration-200 ease-out group-hover:translate-x-12">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span class="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-200">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span className="relative flex items-center">
              <MdStars className="mr-1 text-black text-2xl" />{" "}
              <span className="text-black transition-colors duration-200 ease-in-out delay-100 group-hover:text-white">
                Premium
              </span>
            </span>
          </Link>
          <Link
            to="/credit-card/reward-credit-card"
            className="relative inline-flex items-center justify-start py-3 pl-4 pr-12 overflow-hidden font-semibold text-indigo-600 transition-all duration-150 ease-in-out rounded hover:pl-10 hover:pr-6 bg-gray-50 group"
          >
            <span class="absolute bottom-0 left-0 w-full h-1 transition-all duration-150 ease-in-out bg-indigo-600 group-hover:h-full"></span>
            <span class="absolute right-0 pr-4 duration-200 ease-out group-hover:translate-x-12">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span class="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-200">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span className="relative flex items-center">
              <FaGift className="mr-1 text-black text-2xl" />{" "}
              <span className="text-black transition-colors duration-200 ease-in-out delay-100 group-hover:text-white">
              Reward
              </span>
            </span>
          </Link>
          <Link
            to="/credit-card/business-credit-card"
            className="relative inline-flex items-center justify-start py-3 pl-4 pr-12 overflow-hidden font-semibold text-indigo-600 transition-all duration-150 ease-in-out rounded hover:pl-10 hover:pr-6 bg-gray-50 group"
          >
            <span class="absolute bottom-0 left-0 w-full h-1 transition-all duration-150 ease-in-out bg-indigo-600 group-hover:h-full"></span>
            <span class="absolute right-0 pr-4 duration-200 ease-out group-hover:translate-x-12">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span class="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-200">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span className="relative flex items-center">
              <FaBriefcase className="mr-1 text-black text-2xl" />{" "}
              <span className="text-black transition-colors duration-200 ease-in-out delay-100 group-hover:text-white">
              Business
              </span>
            </span>
          </Link>
          <Link
            to="/credit-card/lifestyle-credit-card"
            className="relative inline-flex items-center justify-start py-3 pl-4 pr-12 overflow-hidden font-semibold text-indigo-600 transition-all duration-150 ease-in-out rounded hover:pl-10 hover:pr-6 bg-gray-50 group"
          >
            <span class="absolute bottom-0 left-0 w-full h-1 transition-all duration-150 ease-in-out bg-indigo-600 group-hover:h-full"></span>
            <span class="absolute right-0 pr-4 duration-200 ease-out group-hover:translate-x-12">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span class="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-200">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span className="relative flex items-center">
              <MdCardMembership className="mr-1 text-black text-2xl" />{" "}
              <span className="text-black transition-colors duration-200 ease-in-out delay-100 group-hover:text-white">
                LifeStyle
              </span>
            </span>
          </Link>
        </div>
        <h1 className="text-center font-bold text-5xl my-10">
          Featured Credit Cards
        </h1>
        <div className="w-[95%] mx-auto flex gap-5 flex-wrap md:flex-nowrap justify-center mb-10">
          <div className="w-fit flex flex-col gap-8">
            {currentCards &&
              currentCards.map((item, index) => {
                return (
                  <>
                    {" "}
                    <CardComponent
                      key={index}
                      cardDetails={item}
                      Card_features={item?.Card_features}
                      fees={item?.fees}
                      cardName={item?.title}
                      cardImage={item?.image}
                      rating={item?.rating}
                      category={item?.category}
                      status={item?.status}
                      bank_link={item?.bank_link}
                    />{" "}
                  </>
                );
              })}
          </div>

          <div className="w-full relative ">
            <div className="sticky overflow-hidden top-20 w-full h-[500px] flex flex-col justify-between">
              {/* <div className="w-[70%] mx-auto">
                                                                <h2 className="text-center font-medium pt-5 text-lg">
                                                                  <span className="font-semibold text-white">816 people</span>{" "}
                                                                  are on call with our advisors right now
                                                                </h2>
                                                              </div> */}
              <div className="w-full mx-auto">
                <Link
                  to="https://play.google.com/store/apps/details?id=finance.global.travel.niyo&pcampaignid=web_share"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="w-[80%] mx-auto ">
                    <img
                      src="/assets/niyoo.png"
                      alt="Advertisement"
                      target="_blank"
                      rel="noopener noreferrer"
                    />
                  </div>
                </Link>
                <div className="bg-white">
                  {/* <h3 className="text-center text-blue-500 cursor-pointer font-semibold py-2">
                                                                    Know your advisor
                                                                  </h3> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Pagination */}
        <ul className="flex justify-center mt-4">
          {currentCards &&
            CreditCardData.cards?.filter(
              (card) => card.category === "Credit card"
            ).length > 0 &&
            Math.ceil(
              CreditCardData.cards?.filter(
                (card) => card.category === "Credit card"
              ).length / cardsPerPage
            ) > 1 &&
            Array.from({
              length: Math.ceil(
                CreditCardData.cards?.filter(
                  (card) => card.category === "Credit card"
                ).length / cardsPerPage
              ),
            }).map((_, index) => (
              <li key={index} className="mx-1">
                <button
                  className={`px-3 py-1 rounded-lg ${
                    currentPage === index + 1
                      ? "bg-blue-500 text-white"
                      : "bg-gray-200 text-gray-800"
                  }`}
                  onClick={() => paginate(index + 1)}
                >
                  {index + 1}
                </button>
              </li>
            ))}
        </ul>
      </div>

      <div className="flex justify-center items-center  p-4 mt-10">
        <div className="bg-white shadow-lg rounded-2xl p-6 max-w-7xl text-center mt-4">
          <h2 className="text-3xl font-bold text-gray-800 mb-4">
            What is a Lifetime Free Credit Card?
          </h2>
          <p className="text-gray-600 leading-relaxed">
            A lifetime free credit card is a type of credit card that does not
            charge any joining or annual fees for the entire duration of its
            validity. It’s designed for users who want the convenience and
            utility of a credit card without the burden of maintenance costs.
            Despite being free, many of these cards offer decent reward
            programs, fuel surcharge waivers, discounts on select categories,
            and interest-free credit periods. They are a smart choice for
            first-time cardholders, students, or anyone who wants to build their
            credit history while keeping costs minimal.
          </p>
        </div>
      </div>

      <div className="px-4 py-10 md:px-8 max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-800 text-center mb-4">
          📝 How to Apply for a Lifetime Free Credit Card
        </h2>
        <p className="text-gray-600 text-sm md:text-base mt-2 text-center mb-8">
          Applying for a lifetime free credit card through TheFinMaster.com is
          straightforward. Here’s how the process works:
        </p>
        <div className="grid gap-6 md:grid-cols-2">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              className="flex items-start gap-4 p-4 rounded-xl bg-white dark:bg-gray-900 shadow-md border hover:shadow-lg transition"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <div className="mt-1">{step.icon}</div>
              <div>
                <h3 className="text-lg font-semibold text-gray-800 dark:text-white mb-1">{`${
                  index + 1
                }. ${step.title}`}</h3>
                <p className="text-md text-gray-600 dark:text-gray-300">
                  {step.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>

      <div className="w-full px-2 py-10 bg-gradient-to-br from-sky-50 via-white to-sky-100 dark:from-gray-900 dark:to-gray-800">
        <div className="max-w-6xl mx-auto grid gap-10">
          <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-lg p-6 md:p-10 border border-sky-200 dark:border-gray-700 hover:shadow-xl transition-shadow">
            <div className="flex items-center gap-3 mb-6">
              <FileText className="w-8 h-8 text-sky-600" />
              <span className="text-3xl font-bold text-gray-800 dark:text-white">
                Documents Required to Apply for LifeTime Free Credit Card
              </span>
            </div>
            <div className="grid sm:grid-cols-2 gap-6 text-gray-700 dark:text-gray-300">
              <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                <span className="block font-semibold text-gray-900 dark:text-white">
                  Identity Proof
                </span>
                <span> PAN Card (mandatory)</span>
              </div>
              <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                <span className="block font-semibold text-gray-900 dark:text-white">
                  Address Proof
                </span>
                <span> Aadhaar Card, Passport, or Utility Bill</span>
              </div>
              <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                <span className="block font-semibold text-gray-900 dark:text-white">
                  Income Proof
                </span>
                <span>
                  {" "}
                  Latest salary slip, bank statement (last 3 months), or Form
                  16/ITR for self-employed
                </span>
              </div>
              <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                <span className="block font-semibold text-gray-900 dark:text-white">
                  Photograph
                </span>
                <span> Passport-size color photo</span>
              </div>
            </div>
          </div>

          <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-lg p-6 md:p-10 border border-emerald-200 dark:border-gray-700 hover:shadow-xl transition-shadow">
            <div className="flex items-center gap-3 mb-6">
              <BadgeCheck className="w-8 h-8 text-emerald-600" />
              <span className="text-3xl font-extrabold text-gray-800 dark:text-white">
                Eligibility Criteria to Apply for a LifeTime Free Credit Card
              </span>
            </div>
            <div className="grid sm:grid-cols-2 gap-6 text-gray-700 dark:text-gray-300">
              <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                <span className="block font-semibold text-gray-900 dark:text-white">
                  {" "}
                  Age
                </span>
                <span>
                  {" "}
                  Minimum 21 years for salaried, 25 years for self-employed
                </span>
              </div>
              <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                <span className="block font-semibold text-gray-900 dark:text-white">
                  Monthly income{" "}
                </span>
                <span> ₹15,000–₹30,000 depending on the card </span>
              </div>
              <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                <span className="block font-semibold text-gray-900 dark:text-white">
                  CIBIL Score
                </span>
                <span> Preferably 700 and above </span>
              </div>
              <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                <span className="block font-semibold text-gray-900 dark:text-white">
                  Employment
                </span>
                <span>
                  {" "}
                  Salaried, self-employed, or business professionals with steady
                  income
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="px-4 py-10 md:px-8 max-w-7xl mx-auto mt-4">
        <h2 className="text-3xl font-semibold text-gray-800 text-center mb-10">
          Benefits of a Lifetime Free Credit Card
        </h2>

        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {benefits.map((item, idx) => (
            <div
              key={idx}
              className="bg-white shadow-md rounded-xl p-6 flex flex-col items-start gap-4 hover:shadow-xl transition duration-300"
            >
              {item.icon}
              <h3 className="text-xl font-semibold">{item.title}</h3>
              <p className="text-gray-600 text-md">{item.description}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-16">
        <h2 className="text-3xl font-bold text-gray-900 text-center mb-6">
          🔍 Key Factors to Consider While Choosing the Best Lifetime Free
          Credit Card{" "}
        </h2>
        {/* <p className="text-gray-600 text-base md:text-lg text-center max-w-2xl mx-auto mb-12">
    Selecting the right fuel credit card goes beyond just fuel discounts. It’s about ensuring consistent savings, ease of use, and long-term value. Here are the key elements to evaluate before making your choice:
  </p> */}

        <div className="space-y-10 divide-y divide-gray-300">
          {factors.map((item, index) => (
            <div key={index} className="flex items-start gap-5 pt-8">
              <div className="text-blue-600 shrink-0">
                <item.icon size={32} className="mt-1.5" />
              </div>
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-1">
                  {item.title}
                </h3>
                <p className="text-gray-600 text-base leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-12 text-gray-800">
        {/* Section Title */}
        {/* Section Title */}
        <h2 className="text-3xl font-bold text-center mb-6">
          Why Opt for a Lifetime Free Credit Card?
        </h2>

        <p className="text-base md:text-md text-center mb-14 max-w-4xl mx-auto text-gray-800">
          Choosing a lifetime free card allows you to enjoy the benefits of
          credit usage without paying annual maintenance costs, making it a
          great starter card. It’s suitable for students, new professionals, or
          those looking to improve their credit score. Moreover, these cards are
          ideal as secondary cards to manage smaller expenses, thereby reducing
          credit utilization on primary premium cards. With no fees attached,
          there’s virtually no downside to keeping such a card active for
          long-term credit health.{" "}
        </p>

        {/* Comparison Table */}
        <h3 className="text-3xl font-semibold text-center mb-8">
          Premium Credit Card vs Normal Credit Card: A Comparative Snapshot
        </h3>
        {/* Styled Table */}
        <div className="overflow-x-auto w-full">
          <table className="min-w-[600px] border-separate border-spacing-y-2 text-left text-base text-gray-700">
            {/* Mobile-Friendly Table Alternative */}
            <div className="space-y-6 md:hidden">
              {[
                [
                  "Annual Fees",
                  "₹0 forever",
                  "₹500–₹10,000+ depending on features",
                ],
                ["Rewards", "Basic to Moderate", "Moderate to Premium"],
                ["Eligibility", "Easy to Moderate", "Moderate to Strict"],
                [
                  "Perks",
                  "Essential Benefits",
                  "Extensive Lifestyle & Travel Perks",
                ],
                [
                  "Ideal For",
                  "Beginners, Budget Users",
                  "Frequent Travelers, High Spenders",
                ],
              ].map(([feature, fuel, regular], i) => (
                <div
                  key={i}
                  className="border rounded-xl p-4 shadow-sm bg-white"
                >
                  <p className="font-semibold text-gray-800 mb-2">{feature}</p>
                  <div className="text-sm text-gray-700">
                    <p>
                      <span className="font-semibold">Lifetime Free Card:</span>{" "}
                      {fuel}
                    </p>
                    <p>
                      <span className="font-semibold">
                        Regular Credit Card:
                      </span>{" "}
                      {regular}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            {/* Desktop Table */}
            <div className="hidden md:block overflow-x-auto">
              <table className="min-w-full border-separate border-spacing-y-2 text-left text-base text-gray-700">
                <thead className="bg-blue-50 text-gray-800">
                  <tr>
                    <th className="px-4 py-3 font-semibold">Feature</th>
                    <th className="px-4 py-3 font-semibold">
                      Lifetime Free Card
                    </th>
                    <th className="px-4 py-3 font-semibold">
                      Regular Credit Card
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    [
                      "Annual Fees",
                      "₹0 forever",
                      "₹500–₹10,000+ depending on features",
                    ],
                    ["Rewards", "Basic to Moderate", "Moderate to Premium"],
                    ["Eligibility", "Easy to Moderate", "Moderate to Strict"],
                    [
                      "Perks",
                      "Essential Benefits",
                      "Extensive Lifestyle & Travel Perks",
                    ],
                    [
                      "Ideal For",
                      "Beginners, Budget Users",
                      "Frequent Travelers, High Spenders",
                    ],
                  ].map(([feature, fuel, regular], i) => (
                    <tr
                      key={i}
                      className={i % 2 === 0 ? "bg-white" : "bg-gray-50"}
                    >
                      <td className="px-4 py-3 font-medium">{feature}</td>
                      <td className="px-4 py-3">{fuel}</td>
                      <td className="px-4 py-3">{regular}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </table>
        </div>
      </div>
      <div className="max-w-4xl mx-auto py-6">
        <h1 className="text-2xl md:text-3xl font-semibold text-center mb-8">
          Frequently Asked Questions
        </h1>
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border rounded-lg overflow-hidden shadow-md"
            >
              <button
                onClick={() => toggleAccordion(index)}
                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
              >
                {faq.question}
                <Icon id={index} open={activeIndex} />
              </button>
              {activeIndex === index && (
                <div className="p-4 bg-gray-100">
                  <p className="text-gray-700">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default LifeTimeFee;

// import React, { useEffect, useState } from 'react'
// import CardComponent from '../cardComponents/CardComponent'
// import AccordionComponent from '../accordion/AccordionComponent'
// // import { CreditCardData } from './CardData'
// import Http from '../../Http'
// import { CARD_API } from '../../Helper'
// import { Link, useLocation } from 'react-router-dom'

// const LifeTimeFee = () => {
//     const [CreditCardData,setCreditCardData] = useState([])
//     const [currentPage, setCurrentPage] = useState(1);
//     const [cardsPerPage] = useState(10);
//     const location = useLocation();
//     const cardData = location.state;
//     console.log(cardData, location.state)

//     const indexOfLastCard = currentPage * cardsPerPage;
//     const indexOfFirstCard = indexOfLastCard - cardsPerPage;
//     console.log({indexOfLastCard,indexOfFirstCard})
//     console.log({cardData})
//     const currentCards = Array.isArray(cardData) && cardData.filter((cards)=>cards.category_name==="Lifetime Free").slice(indexOfFirstCard, indexOfLastCard);
//     console.log({currentCards})
//    // const currentCards = CreditCardData.cards?.filter((card)=>card.category_name==="Life Time Fee").slice(indexOfFirstCard, indexOfLastCard);
//     //console.log({currentCards})

//     const paginate = (pageNumber) => setCurrentPage(pageNumber);

//     return (
//         <div className='w-full flex flex-col items-center '>

//             <div className='w-full flex flex-col items-center justify-center bg-black h-[200px] md:h-[300px] shadow-lg mb-5 border-b-8 border-blue-600'>
//                 <h1 className='text-white md:text-7xl text-centerz-20 font-medium'>
//                     LifeTime Free Card
//                 </h1>
//                 <p className='text-gray-200 text-2xl pt-2'>Experience financial freedom and flexibility with our credit card options.</p>
//                 {/* <img className='w-[100%] h-[100%] object-cover' src='https://www.kotak.com/content/dam/Kotak/guidance/hero-slider-banner/hacks-for-being-regular-with-personal-loan-repayments-hero-desktop.jpg' alt='personalLoan' /> */}

//             </div>

//             <h1 className='text-center font-bold text-5xl my-10'>Featured Credit Cards</h1>
//             <div className='w-[95%] mx-auto flex gap-5 flex-wrap md:flex-nowrap justify-center mb-10'>
//                 <div className='w-fit flex flex-col gap-8'>
//                     {
//                         currentCards &&
//                         currentCards.map((item, index) => {
//                             return <> <CardComponent key={index} cardDetails={item}  Card_features={item?.Card_features} fees={item?.fees} cardName={item?.title} cardImage={item?.image} rating={item?.rating} category={item?.category} status={item?.status} /> </>
//                         })
//                     }
//                 </div>

//                 <div className='w-full relative '>
//                     <div className='sticky overflow-hidden top-20 shadow-lg w-full h-[230px] rounded-2xl bg-blue-500 border flex flex-col justify-between'>
//                         <div className='w-[70%] mx-auto'>
//                             <h2 className='text-center font-medium pt-5 text-lg'><span className='font-semibold text-white'>816 people</span> are on call with our advisors right now</h2>
//                         </div>
//                         <div className='w-full mx-auto'>
//                             <div className='w-[70%] mx-auto'>
//                                 <img src='https://static.pbcdn.in/health-cdn/images/insurer-logo/quotes-logos/advisors-logo.png' alt='imgg' />
//                             </div>
//                             <div className='bg-white'>
//                                 <h3 className='text-center text-blue-500 cursor-pointer font-semibold py-2'>Know your advisor</h3>
//                             </div>
//                         </div>
//                     </div>

//                 </div>

//             </div>
//                    {/* Pagination */}
//                    <ul className='flex justify-center mt-4'>
//                 {currentCards &&
//                      CreditCardData.cards?.filter((card)=>card.category==="Credit card").length > 0 &&
//                     Math.ceil( CreditCardData.cards?.filter((card)=>card.category==="Credit card").length / cardsPerPage) > 1 &&
//                     Array.from({ length: Math.ceil( CreditCardData.cards?.filter((card)=>card.category==="Credit card").length / cardsPerPage) }).map((_, index) => (
//                         <li key={index} className='mx-1'>
//                             <button
//                                 className={`px-3 py-1 rounded-lg ${
//                                     currentPage === index + 1 ? 'bg-blue-500 text-white' : 'bg-gray-200 text-gray-800'
//                                 }`}
//                                 onClick={() => paginate(index + 1)}
//                             >
//                                 {index + 1}
//                             </button>
//                         </li>
//                     ))}
//             </ul>

//             <div className='w-[95%] py-10'>
//                 <h1 className='text-center font-bold text-5xl my-10'>Frequently Asked Questions</h1>
//                 <AccordionComponent />
//             </div>
//         </div>
//     )
// }

// export default LifeTimeFee
